import * as React from 'react';
import { Card } from 'antd';

type Props = {
  /**
   * The Header Text, with it, no Header
   */
  title?: string;
  /**
   * The Component that goes on the upper right in the header, usually a button
   */
  extra?: React.ReactNode;
  children: React.ReactNode;
};

const Container = ({ title, extra, children }: Props) => (
  <Card title={title} extra={extra}>
    {children}
  </Card>
);

export default Container;
